import React, { useState } from 'react';
import { withGoogleMap, withScriptjs, GoogleMap, Marker } from 'react-google-maps';
import classnames from 'classnames';

import { FormattedMessage } from 'react-intl';

import { MainForm } from 'Form';
import getInitialUserData from 'Form/utils';
import { withScrollTo } from 'Lib/scroll-to';
import { GOOGLEMAPSAPIKEY } from 'Common/constants';
import messages from '../messages';
import { Api } from '../api';
import Pen from '../assets/pen';
import MapMarker from '../assets/map-marker';

export const GoogleMaps = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      ref={props.onMapLoad}
      defaultZoom={parseInt(props.markers[0].zoom, 10)}
      defaultCenter={{
        lat: props.markers[0].position.lat,
        lng: props.markers[0].position.lng,
      }}
      onClick={props.onMapClick}>
      {props.markers.map((marker, index) => {
        console.log('kuku', marker);
        return <Marker {...marker} onRightClick={() => props.onMarkerRightClick(index)} />;
      })}
    </GoogleMap>
  ))
);

export const DetailView = ({ data, closeItem, currentState, stateDetail = '', setStateDetail }) => {
  const { region } = currentState.params;
  console.log('lat:', parseFloat(data.latitude), 'lng:', parseFloat(data.longitude));
  const markers = [
    {
      position: {
        lat: parseFloat(data.latitude),
        lng: parseFloat(data.longitude),
      },
      zoom: data.zoom,
      key: data.title,
      defaultAnimation: 2,
    },
  ];

  const formName = 'OrgRequestFormModel';
  const formConfig = {
    form: 'map_application_form',
    formType: 3,
    authorityId: data.authority_id,
    initialValues: getInitialUserData(formName),
    isNormalForm: false,
    formName,
  }; // configuration for `reduxForm`

  const prepareFormData = (formData) => {
    formData.authority_id = data.authority_id;
    formData.is_agree = 1;
    return formData;
  };
  const [state, setState] = useState(stateDetail);
  const changeStateContent = (state) => () => {
    setState(state);
    setStateDetail(state);
  };

  return (
    <div className="direction-overlay">
      <div className="over-top">
        <div className="overlay-left clearfix">
          <div className={classnames('close', 'clearfix')} onClick={closeItem}>
            <FormattedMessage {...messages.close} />
          </div>
          <div
            className={classnames('contacts', 'clearfix', { active: state === 'contacts' })}
            onClick={changeStateContent('contacts')}>
            <MapMarker color={state !== 'contacts' ? '#2B9ED9' : '#fff'} style={{ width: 20, marginRight: 10 }} />
            <FormattedMessage {...messages.contacts} />
          </div>
          <div
            className={classnames('appeal', 'clearfix', { active: state === 'appeal' })}
            onClick={changeStateContent('appeal')}>
            <Pen color={state !== 'appeal' ? '#81C67A' : '#fff'} style={{ width: 20, marginRight: 10 }} />
            <FormattedMessage {...messages.appeal} />
          </div>
        </div>
        <div className="overlay-list clearfix">
          {state === 'contacts' && (
            <React.Fragment>
              <div className="direction-info clearfix">
                <h4 className="title">
                  {region.title} {data.title}
                </h4>
              </div>
              <div className="location-data">
                <table className="location-data-table">
                  <tbody>
                    <tr>
                      <td>
                        <FormattedMessage {...messages.address} />
                      </td>
                      <td>{data.address}</td>
                    </tr>
                    <tr>
                      <td>
                        <FormattedMessage {...messages.phone} />
                      </td>
                      <td>{data.phone}</td>
                    </tr>
                    <tr>
                      <td>
                        <FormattedMessage {...messages.onMap} />
                      </td>
                      <td>
                        <GoogleMaps
                          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${GOOGLEMAPSAPIKEY}`}
                          loadingElement={<div style={{ height: '400px' }}>Loading...</div>}
                          containerElement={<div style={{ height: '400px' }} />}
                          mapElement={<div style={{ height: '100%' }} />}
                          onMapLoad={null}
                          onMapClick={null}
                          markers={markers}
                          onMarkerRightClick={null}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          )}
          {state === 'appeal' && (
            <React.Fragment>
              <div className="direction-info clearfix">
                <h4 className="title">
                  {region.title} {data.title}
                </h4>
              </div>
              <MainForm
                normalForm={false}
                formConfig={formConfig}
                apiSubmitPromise={Api.submitApplication}
                authorityData={data}
                prepareFormDataCb={prepareFormData}
                apiResponseOkHandleCb={(resp) => resp}
                apiResponseErrorHandleCb={(resp) => resp}
                full={false}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default withScrollTo('map_app_root')(DetailView);



// WEBPACK FOOTER //
// ./src/apps/receptions/views/Detail.js